import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=6b1975fd&scoped=true&"
import script from "./ProfileList.vue?vue&type=script&lang=ts&"
export * from "./ProfileList.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileList.vue?vue&type=style&index=0&id=6b1975fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1975fd",
  null
  
)

export default component.exports